var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:local(\"Roboto\"),local(\"Roboto-Regular\"),url(" + escape(require("./Roboto.ttf")) + ") format(\"truetype\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/core/public/fonts.css
// module id = 168
// module chunks = 0